//#region src/app/index.ts
var e = {
	id: "inginuiti",
	name: "Inginuiti",
	description: "Inginuiti application",
	repository: {
		owner: "",
		name: ""
	}
}, t = /* @__PURE__ */ function(e) {
	return e.READ = "read", e.WRITE = "write", e.UPDATE = "update", e.DELETE = "delete", e.MANAGE = "manage", e;
}({}), n = /* @__PURE__ */ function(e) {
	return e.ALL = "all", e.USER = "user", e.ORGANIZATION = "organization", e.PROJECT = "project", e.BILLING = "billing", e.DOCUMENT = "document", e.RESEARCH = "research", e;
}({}), r = /* @__PURE__ */ function(e) {
	return e.ADMIN = "admin", e.MEMBER = "member", e;
}({});
//#endregion
//#region src/permissions/presets.ts
function i(e, t) {
	return `${e}:${t}`;
}
function a(e) {
	let t = e.indexOf(":");
	return t === -1 ? {
		action: e,
		subject: "all"
	} : {
		action: e.slice(0, t),
		subject: e.slice(t + 1)
	};
}
var o = i, s = {
	[r.ADMIN]: [o(t.MANAGE, n.ALL), o(t.MANAGE, n.BILLING)],
	[r.MEMBER]: [
		o(t.READ, n.ORGANIZATION),
		o(t.READ, n.USER),
		o(t.MANAGE, n.PROJECT),
		o(t.READ, n.RESEARCH),
		o(t.READ, n.DOCUMENT),
		o(t.WRITE, n.DOCUMENT)
	]
}, c = /* @__PURE__ */ function(e) {
	return e.ACTIVE = "active", e.INACTIVE = "inactive", e.PENDING = "pending", e;
}({}), l = /* @__PURE__ */ function(e) {
	return e.PENDING = "pending", e.ACCEPTED = "accepted", e.REVOKED = "revoked", e.CANCELLED = "cancelled", e.EXPIRED = "expired", e;
}({});
Object.freeze({ status: "aborted" });
function u(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var d = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, f = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
}, p = {};
function m(e) {
	return e && Object.assign(p, e), p;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/util.js
function ee(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function te(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function ne(e) {
	return { get value() {
		{
			let t = e();
			return Object.defineProperty(this, "value", { value: t }), t;
		}
		throw Error("cached value already set");
	} };
}
function re(e) {
	return e == null;
}
function ie(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function ae(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = t.toString(), i = (r.split(".")[1] || "").length;
	if (i === 0 && /\d?e-\d?/.test(r)) {
		let e = r.match(/\d?e-(\d?)/);
		e?.[1] && (i = Number.parseInt(e[1]));
	}
	let a = n > i ? n : i;
	return Number.parseInt(e.toFixed(a).replace(".", "")) % Number.parseInt(t.toFixed(a).replace(".", "")) / 10 ** a;
}
var oe = Symbol("evaluating");
function h(e, t, n) {
	let r;
	Object.defineProperty(e, t, {
		get() {
			if (r !== oe) return r === void 0 && (r = oe, r = n()), r;
		},
		set(n) {
			Object.defineProperty(e, t, { value: n });
		},
		configurable: !0
	});
}
function g(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function _(...e) {
	let t = {};
	for (let n of e) Object.assign(t, Object.getOwnPropertyDescriptors(n));
	return Object.defineProperties({}, t);
}
function se(e) {
	return JSON.stringify(e);
}
function ce(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var le = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function v(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var ue = ne(() => {
	if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function y(e) {
	if (v(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return !(v(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function de(e) {
	return y(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
var fe = new Set([
	"string",
	"number",
	"symbol"
]);
function b(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function x(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function S(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function pe(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var me = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function he(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	return x(e, _(e._zod.def, {
		get shape() {
			let e = {};
			for (let r in t) {
				if (!(r in n.shape)) throw Error(`Unrecognized key: "${r}"`);
				t[r] && (e[r] = n.shape[r]);
			}
			return g(this, "shape", e), e;
		},
		checks: []
	}));
}
function ge(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	return x(e, _(e._zod.def, {
		get shape() {
			let r = { ...e._zod.def.shape };
			for (let e in t) {
				if (!(e in n.shape)) throw Error(`Unrecognized key: "${e}"`);
				t[e] && delete r[e];
			}
			return g(this, "shape", r), r;
		},
		checks: []
	}));
}
function _e(e, t) {
	if (!y(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = e._zod.def.shape;
		for (let e in t) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return x(e, _(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return g(this, "shape", n), n;
	} }));
}
function ve(e, t) {
	if (!y(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return x(e, _(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return g(this, "shape", n), n;
	} }));
}
function ye(e, t) {
	return x(e, _(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t._zod.def.shape
			};
			return g(this, "shape", n), n;
		},
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: []
	}));
}
function be(e, t, n) {
	let r = t._zod.def.checks;
	if (r && r.length > 0) throw Error(".partial() cannot be used on object schemas containing refinements");
	return x(t, _(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in r)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = e ? new e({
					type: "optional",
					innerType: r[t]
				}) : r[t]);
			}
			else for (let t in r) i[t] = e ? new e({
				type: "optional",
				innerType: r[t]
			}) : r[t];
			return g(this, "shape", i), i;
		},
		checks: []
	}));
}
function xe(e, t, n) {
	return x(t, _(t._zod.def, { get shape() {
		let r = t._zod.def.shape, i = { ...r };
		if (n) for (let t in n) {
			if (!(t in i)) throw Error(`Unrecognized key: "${t}"`);
			n[t] && (i[t] = new e({
				type: "nonoptional",
				innerType: r[t]
			}));
		}
		else for (let t in r) i[t] = new e({
			type: "nonoptional",
			innerType: r[t]
		});
		return g(this, "shape", i), i;
	} }));
}
function C(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function w(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function T(e) {
	return typeof e == "string" ? e : e?.message;
}
function E(e, t, n) {
	let r = {
		...e,
		path: e.path ?? []
	};
	return e.message || (r.message = T(e.inst?._zod.def?.error?.(e)) ?? T(t?.error?.(e)) ?? T(n.customError?.(e)) ?? T(n.localeError?.(e)) ?? "Invalid input"), delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function Se(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function D(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/errors.js
var Ce = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, te, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, we = u("$ZodError", Ce), Te = u("$ZodError", Ce, { Parent: Error });
function Ee(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function De(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e) => {
		for (let i of e.issues) if (i.code === "invalid_union" && i.errors.length) i.errors.map((e) => r({ issues: e }));
		else if (i.code === "invalid_key") r({ issues: i.issues });
		else if (i.code === "invalid_element") r({ issues: i.issues });
		else if (i.path.length === 0) n._errors.push(t(i));
		else {
			let e = n, r = 0;
			for (; r < i.path.length;) {
				let n = i.path[r];
				r === i.path.length - 1 ? (e[n] = e[n] || { _errors: [] }, e[n]._errors.push(t(i))) : e[n] = e[n] || { _errors: [] }, e = e[n], r++;
			}
		}
	};
	return r(e), n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/parse.js
var Oe = (e) => (t, n, r, i) => {
	let a = r ? Object.assign(r, { async: !1 }) : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new d();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => E(e, a, m())));
		throw le(t, i?.callee), t;
	}
	return o.value;
}, ke = (e) => async (t, n, r, i) => {
	let a = r ? Object.assign(r, { async: !0 }) : { async: !0 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise && (o = await o), o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => E(e, a, m())));
		throw le(t, i?.callee), t;
	}
	return o.value;
}, Ae = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new d();
	return a.issues.length ? {
		success: !1,
		error: new (e ?? we)(a.issues.map((e) => E(e, i, m())))
	} : {
		success: !0,
		data: a.value
	};
}, je = /* @__PURE__ */ Ae(Te), Me = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { async: !0 }) : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? {
		success: !1,
		error: new e(a.issues.map((e) => E(e, i, m())))
	} : {
		success: !0,
		data: a.value
	};
}, Ne = /* @__PURE__ */ Me(Te), Pe = (e) => (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Oe(e)(t, n, i);
}, Fe = (e) => (t, n, r) => Oe(e)(t, n, r), Ie = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return ke(e)(t, n, i);
}, Le = (e) => async (t, n, r) => ke(e)(t, n, r), Re = (e) => (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Ae(e)(t, n, i);
}, ze = (e) => (t, n, r) => Ae(e)(t, n, r), Be = (e) => async (t, n, r) => {
	let i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
	return Me(e)(t, n, i);
}, Ve = (e) => async (t, n, r) => Me(e)(t, n, r), He = /^[cC][^\s-]{8,}$/, Ue = /^[0-9a-z]+$/, We = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Ge = /^[0-9a-vA-V]{20}$/, Ke = /^[A-Za-z0-9]{27}$/, qe = /^[a-zA-Z0-9_-]{21}$/, Je = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Ye = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Xe = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Ze = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Qe = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function $e() {
	return new RegExp(Qe, "u");
}
var et = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, tt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, nt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, rt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, it = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, at = /^[A-Za-z0-9_-]*$/, ot = /^\+[1-9]\d{6,14}$/, st = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", ct = /* @__PURE__ */ RegExp(`^${st}$`);
function lt(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function ut(e) {
	return RegExp(`^${lt(e)}$`);
}
function dt(e) {
	let t = lt({ precision: e.precision }), n = ["Z"];
	e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let r = `${t}(?:${n.join("|")})`;
	return RegExp(`^${st}T(?:${r})$`);
}
var ft = (e) => {
	let t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
	return RegExp(`^${t}$`);
}, pt = /^-?\d+$/, mt = /^-?\d+(?:\.\d+)?$/, ht = /^(?:true|false)$/i, gt = /^[^A-Z]*$/, _t = /^[^a-z]*$/, O = /* @__PURE__ */ u("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), vt = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, yt = /* @__PURE__ */ u("$ZodCheckLessThan", (e, t) => {
	O.init(e, t);
	let n = vt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Infinity;
		t.value < r && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), bt = /* @__PURE__ */ u("$ZodCheckGreaterThan", (e, t) => {
	O.init(e, t);
	let n = vt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? -Infinity;
		t.value > r && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), xt = /* @__PURE__ */ u("$ZodCheckMultipleOf", (e, t) => {
	O.init(e, t), e._zod.onattach.push((e) => {
		var n;
		(n = e._zod.bag).multipleOf ?? (n.multipleOf = t.value);
	}), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : ae(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), St = /* @__PURE__ */ u("$ZodCheckNumberFormat", (e, t) => {
	O.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = me[t.format];
	e._zod.onattach.push((e) => {
		let r = e._zod.bag;
		r.format = t.format, r.minimum = i, r.maximum = a, n && (r.pattern = pt);
	}), e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), Ct = /* @__PURE__ */ u("$ZodCheckMaxLength", (e, t) => {
	var n;
	O.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !re(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.maximum ?? Infinity;
		t.maximum < n && (e._zod.bag.maximum = t.maximum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length <= t.maximum) return;
		let i = Se(r);
		n.issues.push({
			origin: i,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), wt = /* @__PURE__ */ u("$ZodCheckMinLength", (e, t) => {
	var n;
	O.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !re(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.minimum ?? -Infinity;
		t.minimum > n && (e._zod.bag.minimum = t.minimum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length >= t.minimum) return;
		let i = Se(r);
		n.issues.push({
			origin: i,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Tt = /* @__PURE__ */ u("$ZodCheckLengthEquals", (e, t) => {
	var n;
	O.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !re(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.minimum = t.length, n.maximum = t.length, n.length = t.length;
	}), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if (i === t.length) return;
		let a = Se(r), o = i > t.length;
		n.issues.push({
			origin: a,
			...o ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Et = /* @__PURE__ */ u("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	O.init(e, t), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.format = t.format, t.pattern && (n.patterns ??= /* @__PURE__ */ new Set(), n.patterns.add(t.pattern));
	}), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), Dt = /* @__PURE__ */ u("$ZodCheckRegex", (e, t) => {
	Et.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), Ot = /* @__PURE__ */ u("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= gt, Et.init(e, t);
}), kt = /* @__PURE__ */ u("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= _t, Et.init(e, t);
}), At = /* @__PURE__ */ u("$ZodCheckIncludes", (e, t) => {
	O.init(e, t);
	let n = b(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
	t.pattern = r, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(r);
	}), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), jt = /* @__PURE__ */ u("$ZodCheckStartsWith", (e, t) => {
	O.init(e, t);
	let n = RegExp(`^${b(t.prefix)}.*`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Mt = /* @__PURE__ */ u("$ZodCheckEndsWith", (e, t) => {
	O.init(e, t);
	let n = RegExp(`.*${b(t.suffix)}$`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Nt = /* @__PURE__ */ u("$ZodCheckOverwrite", (e, t) => {
	O.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), Pt = class {
	constructor(e = []) {
		this.content = [], this.indent = 0, this && (this.args = e);
	}
	indented(e) {
		this.indent += 1, e(this), --this.indent;
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.args, n = [...(this?.content ?? [""]).map((e) => `  ${e}`)];
		return new e(...t, n.join("\n"));
	}
}, Ft = {
	major: 4,
	minor: 3,
	patch: 6
}, k = /* @__PURE__ */ u("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Ft;
	let r = [...e._zod.def.checks ?? []];
	e._zod.traits.has("$ZodCheck") && r.unshift(e);
	for (let t of r) for (let n of t._zod.onattach) n(e);
	if (r.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (e, t, n) => {
			let r = C(e), i;
			for (let a of t) {
				if (a._zod.def.when) {
					if (!a._zod.def.when(e)) continue;
				} else if (r) continue;
				let t = e.issues.length, o = a._zod.check(e);
				if (o instanceof Promise && n?.async === !1) throw new d();
				if (i || o instanceof Promise) i = (i ?? Promise.resolve()).then(async () => {
					await o, e.issues.length !== t && (r ||= C(e, t));
				});
				else {
					if (e.issues.length === t) continue;
					r ||= C(e, t);
				}
			}
			return i ? i.then(() => e) : e;
		}, n = (n, i, a) => {
			if (C(n)) return n.aborted = !0, n;
			let o = t(i, r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new d();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (i, a) => {
			if (a.skipChecks) return e._zod.parse(i, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: i.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, i, a)) : n(t, i, a);
			}
			let o = e._zod.parse(i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new d();
				return o.then((e) => t(e, r, a));
			}
			return t(o, r, a);
		};
	}
	h(e, "~standard", () => ({
		validate: (t) => {
			try {
				let n = je(e, t);
				return n.success ? { value: n.data } : { issues: n.error?.issues };
			} catch {
				return Ne(e, t).then((e) => e.success ? { value: e.data } : { issues: e.error?.issues });
			}
		},
		vendor: "zod",
		version: 1
	}));
}), It = /* @__PURE__ */ u("$ZodString", (e, t) => {
	k.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? ft(e._zod.bag), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), A = /* @__PURE__ */ u("$ZodStringFormat", (e, t) => {
	Et.init(e, t), It.init(e, t);
}), Lt = /* @__PURE__ */ u("$ZodGUID", (e, t) => {
	t.pattern ??= Ye, A.init(e, t);
}), Rt = /* @__PURE__ */ u("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= Xe(e);
	} else t.pattern ??= Xe();
	A.init(e, t);
}), zt = /* @__PURE__ */ u("$ZodEmail", (e, t) => {
	t.pattern ??= Ze, A.init(e, t);
}), Bt = /* @__PURE__ */ u("$ZodURL", (e, t) => {
	A.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim(), i = new URL(r);
			t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.normalize ? n.value = i.href : n.value = r;
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), Vt = /* @__PURE__ */ u("$ZodEmoji", (e, t) => {
	t.pattern ??= $e(), A.init(e, t);
}), Ht = /* @__PURE__ */ u("$ZodNanoID", (e, t) => {
	t.pattern ??= qe, A.init(e, t);
}), Ut = /* @__PURE__ */ u("$ZodCUID", (e, t) => {
	t.pattern ??= He, A.init(e, t);
}), Wt = /* @__PURE__ */ u("$ZodCUID2", (e, t) => {
	t.pattern ??= Ue, A.init(e, t);
}), Gt = /* @__PURE__ */ u("$ZodULID", (e, t) => {
	t.pattern ??= We, A.init(e, t);
}), Kt = /* @__PURE__ */ u("$ZodXID", (e, t) => {
	t.pattern ??= Ge, A.init(e, t);
}), qt = /* @__PURE__ */ u("$ZodKSUID", (e, t) => {
	t.pattern ??= Ke, A.init(e, t);
}), Jt = /* @__PURE__ */ u("$ZodISODateTime", (e, t) => {
	t.pattern ??= dt(t), A.init(e, t);
}), Yt = /* @__PURE__ */ u("$ZodISODate", (e, t) => {
	t.pattern ??= ct, A.init(e, t);
}), Xt = /* @__PURE__ */ u("$ZodISOTime", (e, t) => {
	t.pattern ??= ut(t), A.init(e, t);
}), Zt = /* @__PURE__ */ u("$ZodISODuration", (e, t) => {
	t.pattern ??= Je, A.init(e, t);
}), Qt = /* @__PURE__ */ u("$ZodIPv4", (e, t) => {
	t.pattern ??= et, A.init(e, t), e._zod.bag.format = "ipv4";
}), $t = /* @__PURE__ */ u("$ZodIPv6", (e, t) => {
	t.pattern ??= tt, A.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
		try {
			new URL(`http://[${n.value}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), en = /* @__PURE__ */ u("$ZodCIDRv4", (e, t) => {
	t.pattern ??= nt, A.init(e, t);
}), tn = /* @__PURE__ */ u("$ZodCIDRv6", (e, t) => {
	t.pattern ??= rt, A.init(e, t), e._zod.check = (n) => {
		let r = n.value.split("/");
		try {
			if (r.length !== 2) throw Error();
			let [e, t] = r;
			if (!t) throw Error();
			let n = Number(t);
			if (`${n}` !== t || n < 0 || n > 128) throw Error();
			new URL(`http://[${e}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
});
function nn(e) {
	if (e === "") return !0;
	if (e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var rn = /* @__PURE__ */ u("$ZodBase64", (e, t) => {
	t.pattern ??= it, A.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
		nn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function an(e) {
	if (!at.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return nn(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var on = /* @__PURE__ */ u("$ZodBase64URL", (e, t) => {
	t.pattern ??= at, A.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
		an(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), sn = /* @__PURE__ */ u("$ZodE164", (e, t) => {
	t.pattern ??= ot, A.init(e, t);
});
function cn(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var ln = /* @__PURE__ */ u("$ZodJWT", (e, t) => {
	A.init(e, t), e._zod.check = (n) => {
		cn(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), un = /* @__PURE__ */ u("$ZodNumber", (e, t) => {
	k.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? mt, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), dn = /* @__PURE__ */ u("$ZodNumberFormat", (e, t) => {
	St.init(e, t), un.init(e, t);
}), fn = /* @__PURE__ */ u("$ZodBoolean", (e, t) => {
	k.init(e, t), e._zod.pattern = ht, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = !!n.value;
		} catch {}
		let i = n.value;
		return typeof i == "boolean" || n.issues.push({
			expected: "boolean",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
	};
}), pn = /* @__PURE__ */ u("$ZodUnknown", (e, t) => {
	k.init(e, t), e._zod.parse = (e) => e;
}), mn = /* @__PURE__ */ u("$ZodNever", (e, t) => {
	k.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
}), hn = /* @__PURE__ */ u("$ZodDate", (e, t) => {
	k.init(e, t), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = new Date(n.value);
		} catch {}
		let i = n.value, a = i instanceof Date;
		return a && !Number.isNaN(i.getTime()) || n.issues.push({
			expected: "date",
			code: "invalid_type",
			input: i,
			...a ? { received: "Invalid Date" } : {},
			inst: e
		}), n;
	};
});
function gn(e, t, n) {
	e.issues.length && t.issues.push(...w(n, e.issues)), t.value[n] = e.value;
}
var _n = /* @__PURE__ */ u("$ZodArray", (e, t) => {
	k.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Array.isArray(i)) return n.issues.push({
			expected: "array",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		n.value = Array(i.length);
		let a = [];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = t.element._zod.run({
				value: o,
				issues: []
			}, r);
			s instanceof Promise ? a.push(s.then((t) => gn(t, n, e))) : gn(s, n, e);
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
});
function vn(e, t, n, r, i) {
	if (e.issues.length) {
		if (i && !(n in r)) return;
		t.issues.push(...w(n, e.issues));
	}
	e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function yn(e) {
	let t = Object.keys(e.shape);
	for (let n of t) if (!e.shape?.[n]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${n}": expected a Zod schema`);
	let n = pe(e.shape);
	return {
		...e,
		keys: t,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(n)
	};
}
function bn(e, t, n, r, i, a) {
	let o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type, u = c.optout === "optional";
	for (let i in t) {
		if (s.has(i)) continue;
		if (l === "never") {
			o.push(i);
			continue;
		}
		let a = c.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => vn(e, n, i, t, u))) : vn(a, n, i, t, u);
	}
	return o.length && n.issues.push({
		code: "unrecognized_keys",
		keys: o,
		input: t,
		inst: a
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var xn = /* @__PURE__ */ u("$ZodObject", (e, t) => {
	if (k.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
		let e = t.shape;
		Object.defineProperty(t, "shape", { get: () => {
			let n = { ...e };
			return Object.defineProperty(t, "shape", { value: n }), n;
		} });
	}
	let n = ne(() => yn(t));
	h(e._zod, "propValues", () => {
		let e = t.shape, n = {};
		for (let t in e) {
			let r = e[t]._zod;
			if (r.values) {
				n[t] ?? (n[t] = /* @__PURE__ */ new Set());
				for (let e of r.values) n[t].add(e);
			}
		}
		return n;
	});
	let r = v, i = t.catchall, a;
	e._zod.parse = (t, o) => {
		a ??= n.value;
		let s = t.value;
		if (!r(s)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: s,
			inst: e
		}), t;
		t.value = {};
		let c = [], l = a.shape;
		for (let e of a.keys) {
			let n = l[e], r = n._zod.optout === "optional", i = n._zod.run({
				value: s[e],
				issues: []
			}, o);
			i instanceof Promise ? c.push(i.then((n) => vn(n, t, e, s, r))) : vn(i, t, e, s, r);
		}
		return i ? bn(c, s, t, o, n.value, e) : c.length ? Promise.all(c).then(() => t) : t;
	};
}), Sn = /* @__PURE__ */ u("$ZodObjectJIT", (e, t) => {
	xn.init(e, t);
	let n = e._zod.parse, r = ne(() => yn(t)), i = (e) => {
		let t = new Pt([
			"shape",
			"payload",
			"ctx"
		]), n = r.value, i = (e) => {
			let t = se(e);
			return `shape[${t}]._zod.run({ value: input[${t}], issues: [] }, ctx)`;
		};
		t.write("const input = payload.value;");
		let a = Object.create(null), o = 0;
		for (let e of n.keys) a[e] = `key_${o++}`;
		t.write("const newResult = {};");
		for (let r of n.keys) {
			let n = a[r], o = se(r), s = e[r]?._zod?.optout === "optional";
			t.write(`const ${n} = ${i(r)};`), s ? t.write(`
        if (${n}.issues.length) {
          if (${o} in input) {
            payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${o}, ...iss.path] : [${o}]
            })));
          }
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : t.write(`
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `);
		}
		t.write("payload.value = newResult;"), t.write("return payload;");
		let s = t.compile();
		return (t, n) => s(e, t, n);
	}, a, o = v, s = !p.jitless, c = s && ue.value, l = t.catchall, u;
	e._zod.parse = (d, f) => {
		u ??= r.value;
		let p = d.value;
		return o(p) ? s && c && f?.async === !1 && f.jitless !== !0 ? (a ||= i(t.shape), d = a(d, f), l ? bn([], p, d, f, u, e) : d) : n(d, f) : (d.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), d);
	};
});
function Cn(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !C(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => E(e, r, m())))
	}), t);
}
var wn = /* @__PURE__ */ u("$ZodUnion", (e, t) => {
	k.init(e, t), h(e._zod, "optin", () => t.options.some((e) => e._zod.optin === "optional") ? "optional" : void 0), h(e._zod, "optout", () => t.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), h(e._zod, "values", () => {
		if (t.options.every((e) => e._zod.values)) return new Set(t.options.flatMap((e) => Array.from(e._zod.values)));
	}), h(e._zod, "pattern", () => {
		if (t.options.every((e) => e._zod.pattern)) {
			let e = t.options.map((e) => e._zod.pattern);
			return RegExp(`^(${e.map((e) => ie(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1, r = t.options[0]._zod.run;
	e._zod.parse = (i, a) => {
		if (n) return r(i, a);
		let o = !1, s = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: i.value,
				issues: []
			}, a);
			if (t instanceof Promise) s.push(t), o = !0;
			else {
				if (t.issues.length === 0) return t;
				s.push(t);
			}
		}
		return o ? Promise.all(s).then((t) => Cn(t, i, e, a)) : Cn(s, i, e, a);
	};
}), Tn = /* @__PURE__ */ u("$ZodDiscriminatedUnion", (e, t) => {
	t.inclusive = !1, wn.init(e, t);
	let n = e._zod.parse;
	h(e._zod, "propValues", () => {
		let e = {};
		for (let n of t.options) {
			let r = n._zod.propValues;
			if (!r || Object.keys(r).length === 0) throw Error(`Invalid discriminated union option at index "${t.options.indexOf(n)}"`);
			for (let [t, n] of Object.entries(r)) {
				e[t] || (e[t] = /* @__PURE__ */ new Set());
				for (let r of n) e[t].add(r);
			}
		}
		return e;
	});
	let r = ne(() => {
		let e = t.options, n = /* @__PURE__ */ new Map();
		for (let r of e) {
			let e = r._zod.propValues?.[t.discriminator];
			if (!e || e.size === 0) throw Error(`Invalid discriminated union option at index "${t.options.indexOf(r)}"`);
			for (let t of e) {
				if (n.has(t)) throw Error(`Duplicate discriminator value "${String(t)}"`);
				n.set(t, r);
			}
		}
		return n;
	});
	e._zod.parse = (i, a) => {
		let o = i.value;
		if (!v(o)) return i.issues.push({
			code: "invalid_type",
			expected: "object",
			input: o,
			inst: e
		}), i;
		let s = r.value.get(o?.[t.discriminator]);
		return s ? s._zod.run(i, a) : t.unionFallback ? n(i, a) : (i.issues.push({
			code: "invalid_union",
			errors: [],
			note: "No matching discriminator",
			discriminator: t.discriminator,
			input: o,
			path: [t.discriminator],
			inst: e
		}), i);
	};
}), En = /* @__PURE__ */ u("$ZodIntersection", (e, t) => {
	k.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => On(e, t, n)) : On(e, i, a);
	};
});
function Dn(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (y(e) && y(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = Dn(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = Dn(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function On(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i;
	for (let n of t.issues) if (n.code === "unrecognized_keys") {
		i ??= n;
		for (let e of n.keys) r.has(e) || r.set(e, {}), r.get(e).l = !0;
	} else e.issues.push(n);
	for (let t of n.issues) if (t.code === "unrecognized_keys") for (let e of t.keys) r.has(e) || r.set(e, {}), r.get(e).r = !0;
	else e.issues.push(t);
	let a = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (a.length && i && e.issues.push({
		...i,
		keys: a
	}), C(e)) return e;
	let o = Dn(t.value, n.value);
	if (!o.valid) throw Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
	return e.value = o.data, e;
}
var kn = /* @__PURE__ */ u("$ZodRecord", (e, t) => {
	k.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!y(i)) return n.issues.push({
			expected: "record",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		let a = [], o = t.keyType._zod.values;
		if (o) {
			n.value = {};
			let s = /* @__PURE__ */ new Set();
			for (let e of o) if (typeof e == "string" || typeof e == "number" || typeof e == "symbol") {
				s.add(typeof e == "number" ? e.toString() : e);
				let o = t.valueType._zod.run({
					value: i[e],
					issues: []
				}, r);
				o instanceof Promise ? a.push(o.then((t) => {
					t.issues.length && n.issues.push(...w(e, t.issues)), n.value[e] = t.value;
				})) : (o.issues.length && n.issues.push(...w(e, o.issues)), n.value[e] = o.value);
			}
			let c;
			for (let e in i) s.has(e) || (c ??= [], c.push(e));
			c && c.length > 0 && n.issues.push({
				code: "unrecognized_keys",
				input: i,
				inst: e,
				keys: c
			});
		} else {
			n.value = {};
			for (let o of Reflect.ownKeys(i)) {
				if (o === "__proto__") continue;
				let s = t.keyType._zod.run({
					value: o,
					issues: []
				}, r);
				if (s instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (typeof o == "string" && mt.test(o) && s.issues.length) {
					let e = t.keyType._zod.run({
						value: Number(o),
						issues: []
					}, r);
					if (e instanceof Promise) throw Error("Async schemas not supported in object keys currently");
					e.issues.length === 0 && (s = e);
				}
				if (s.issues.length) {
					t.mode === "loose" ? n.value[o] = i[o] : n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: s.issues.map((e) => E(e, r, m())),
						input: o,
						path: [o],
						inst: e
					});
					continue;
				}
				let c = t.valueType._zod.run({
					value: i[o],
					issues: []
				}, r);
				c instanceof Promise ? a.push(c.then((e) => {
					e.issues.length && n.issues.push(...w(o, e.issues)), n.value[s.value] = e.value;
				})) : (c.issues.length && n.issues.push(...w(o, c.issues)), n.value[s.value] = c.value);
			}
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
}), An = /* @__PURE__ */ u("$ZodEnum", (e, t) => {
	k.init(e, t);
	let n = ee(t.entries), r = new Set(n);
	e._zod.values = r, e._zod.pattern = RegExp(`^(${n.filter((e) => fe.has(typeof e)).map((e) => typeof e == "string" ? b(e) : e.toString()).join("|")})$`), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), jn = /* @__PURE__ */ u("$ZodLiteral", (e, t) => {
	if (k.init(e, t), t.values.length === 0) throw Error("Cannot create literal schema with no valid values");
	let n = new Set(t.values);
	e._zod.values = n, e._zod.pattern = RegExp(`^(${t.values.map((e) => typeof e == "string" ? b(e) : e ? b(e.toString()) : String(e)).join("|")})$`), e._zod.parse = (r, i) => {
		let a = r.value;
		return n.has(a) || r.issues.push({
			code: "invalid_value",
			values: t.values,
			input: a,
			inst: e
		}), r;
	};
}), Mn = /* @__PURE__ */ u("$ZodTransform", (e, t) => {
	k.init(e, t), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new f(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n));
		if (i instanceof Promise) throw new d();
		return n.value = i, n;
	};
});
function Nn(e, t) {
	return e.issues.length && t === void 0 ? {
		issues: [],
		value: void 0
	} : e;
}
var Pn = /* @__PURE__ */ u("$ZodOptional", (e, t) => {
	k.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", h(e._zod, "values", () => t.innerType._zod.values ? new Set([...t.innerType._zod.values, void 0]) : void 0), h(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ie(e.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (t.innerType._zod.optin === "optional") {
			let r = t.innerType._zod.run(e, n);
			return r instanceof Promise ? r.then((t) => Nn(t, e.value)) : Nn(r, e.value);
		}
		return e.value === void 0 ? e : t.innerType._zod.run(e, n);
	};
}), Fn = /* @__PURE__ */ u("$ZodExactOptional", (e, t) => {
	Pn.init(e, t), h(e._zod, "values", () => t.innerType._zod.values), h(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), In = /* @__PURE__ */ u("$ZodNullable", (e, t) => {
	k.init(e, t), h(e._zod, "optin", () => t.innerType._zod.optin), h(e._zod, "optout", () => t.innerType._zod.optout), h(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ie(e.source)}|null)$`) : void 0;
	}), h(e._zod, "values", () => t.innerType._zod.values ? new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), Ln = /* @__PURE__ */ u("$ZodDefault", (e, t) => {
	k.init(e, t), e._zod.optin = "optional", h(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => Rn(e, t)) : Rn(r, t);
	};
});
function Rn(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var zn = /* @__PURE__ */ u("$ZodPrefault", (e, t) => {
	k.init(e, t), e._zod.optin = "optional", h(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), Bn = /* @__PURE__ */ u("$ZodNonOptional", (e, t) => {
	k.init(e, t), h(e._zod, "values", () => {
		let e = t.innerType._zod.values;
		return e ? new Set([...e].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => Vn(t, e)) : Vn(i, e);
	};
});
function Vn(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
var Hn = /* @__PURE__ */ u("$ZodCatch", (e, t) => {
	k.init(e, t), h(e._zod, "optin", () => t.innerType._zod.optin), h(e._zod, "optout", () => t.innerType._zod.optout), h(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((r) => (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => E(e, n, m())) },
			input: e.value
		}), e.issues = []), e)) : (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => E(e, n, m())) },
			input: e.value
		}), e.issues = []), e);
	};
}), Un = /* @__PURE__ */ u("$ZodPipe", (e, t) => {
	k.init(e, t), h(e._zod, "values", () => t.in._zod.values), h(e._zod, "optin", () => t.in._zod.optin), h(e._zod, "optout", () => t.out._zod.optout), h(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => Wn(e, t.in, n)) : Wn(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => Wn(e, t.out, n)) : Wn(r, t.out, n);
	};
});
function Wn(e, t, n) {
	return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues
	}, n);
}
var Gn = /* @__PURE__ */ u("$ZodReadonly", (e, t) => {
	k.init(e, t), h(e._zod, "propValues", () => t.innerType._zod.propValues), h(e._zod, "values", () => t.innerType._zod.values), h(e._zod, "optin", () => t.innerType?._zod?.optin), h(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(Kn) : Kn(r);
	};
});
function Kn(e) {
	return e.value = Object.freeze(e.value), e;
}
var qn = /* @__PURE__ */ u("$ZodLazy", (e, t) => {
	k.init(e, t), h(e._zod, "innerType", () => t.getter()), h(e._zod, "pattern", () => e._zod.innerType?._zod?.pattern), h(e._zod, "propValues", () => e._zod.innerType?._zod?.propValues), h(e._zod, "optin", () => e._zod.innerType?._zod?.optin ?? void 0), h(e._zod, "optout", () => e._zod.innerType?._zod?.optout ?? void 0), e._zod.parse = (t, n) => e._zod.innerType._zod.run(t, n);
}), Jn = /* @__PURE__ */ u("$ZodCustom", (e, t) => {
	O.init(e, t), k.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => Yn(t, n, r, e));
		Yn(i, n, r, e);
	};
});
function Yn(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(D(e));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/registries.js
var Xn, Zn = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function Qn() {
	return new Zn();
}
(Xn = globalThis).__zod_globalRegistry ?? (Xn.__zod_globalRegistry = Qn());
var j = globalThis.__zod_globalRegistry;
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/api.js
/* @__NO_SIDE_EFFECTS__ */
function $n(e, t) {
	return new e({
		type: "string",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function er(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function tr(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function nr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function rr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ir(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ar(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function or(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function sr(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function cr(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function lr(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ur(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function dr(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function fr(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function pr(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function mr(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function hr(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function gr(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function _r(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function vr(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function yr(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function br(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function xr(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Sr(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Cr(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function wr(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Tr(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Er(e, t) {
	return new e({
		type: "number",
		checks: [],
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Dr(e, t) {
	return new e({
		type: "number",
		coerce: !0,
		checks: [],
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Or(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function kr(e, t) {
	return new e({
		type: "boolean",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ar(e) {
	return new e({ type: "unknown" });
}
/* @__NO_SIDE_EFFECTS__ */
function jr(e, t) {
	return new e({
		type: "never",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Mr(e, t) {
	return new e({
		type: "date",
		...S(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Nr(e, t) {
	return new yt({
		check: "less_than",
		...S(t),
		value: e,
		inclusive: !1
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Pr(e, t) {
	return new yt({
		check: "less_than",
		...S(t),
		value: e,
		inclusive: !0
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Fr(e, t) {
	return new bt({
		check: "greater_than",
		...S(t),
		value: e,
		inclusive: !1
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ir(e, t) {
	return new bt({
		check: "greater_than",
		...S(t),
		value: e,
		inclusive: !0
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Lr(e, t) {
	return new xt({
		check: "multiple_of",
		...S(t),
		value: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Rr(e, t) {
	return new Ct({
		check: "max_length",
		...S(t),
		maximum: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function M(e, t) {
	return new wt({
		check: "min_length",
		...S(t),
		minimum: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function zr(e, t) {
	return new Tt({
		check: "length_equals",
		...S(t),
		length: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Br(e, t) {
	return new Dt({
		check: "string_format",
		format: "regex",
		...S(t),
		pattern: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Vr(e) {
	return new Ot({
		check: "string_format",
		format: "lowercase",
		...S(e)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Hr(e) {
	return new kt({
		check: "string_format",
		format: "uppercase",
		...S(e)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ur(e, t) {
	return new At({
		check: "string_format",
		format: "includes",
		...S(t),
		includes: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Wr(e, t) {
	return new jt({
		check: "string_format",
		format: "starts_with",
		...S(t),
		prefix: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Gr(e, t) {
	return new Mt({
		check: "string_format",
		format: "ends_with",
		...S(t),
		suffix: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function N(e) {
	return new Nt({
		check: "overwrite",
		tx: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Kr(e) {
	return /* @__PURE__ */ N((t) => t.normalize(e));
}
/* @__NO_SIDE_EFFECTS__ */
function qr() {
	return /* @__PURE__ */ N((e) => e.trim());
}
/* @__NO_SIDE_EFFECTS__ */
function Jr() {
	return /* @__PURE__ */ N((e) => e.toLowerCase());
}
/* @__NO_SIDE_EFFECTS__ */
function Yr() {
	return /* @__PURE__ */ N((e) => e.toUpperCase());
}
/* @__NO_SIDE_EFFECTS__ */
function Xr() {
	return /* @__PURE__ */ N((e) => ce(e));
}
/* @__NO_SIDE_EFFECTS__ */
function Zr(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...S(n)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Qr(e, t, n) {
	let r = S(n);
	return r.abort ??= !0, new e({
		type: "custom",
		check: "custom",
		fn: t,
		...r
	});
}
/* @__NO_SIDE_EFFECTS__ */
function $r(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...S(n)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ei(e) {
	let t = /* @__PURE__ */ ti((n) => (n.addIssue = (e) => {
		if (typeof e == "string") n.issues.push(D(e, n.value, t._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", r.input ??= n.value, r.inst ??= t, r.continue ??= !t._zod.def.abort, n.issues.push(D(r));
		}
	}, e(n.value, n)));
	return t;
}
/* @__NO_SIDE_EFFECTS__ */
function ti(e, t) {
	let n = new O({
		check: "custom",
		...S(t)
	});
	return n._zod.check = e, n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/core/to-json-schema.js
function ni(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? j,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		external: e?.external ?? void 0
	};
}
function P(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o);
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, P(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && Object.assign(o.schema, c), t.io === "input" && F(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && o.schema._prefault && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function ri(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${a}`
			};
		}
		if (t[1] === n) return { ref: "#" };
		let i = `#/${r}/`, a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + a
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) {
			a(n);
			continue;
		}
		if (e.external) {
			let r = e.external.registry.get(n[0])?.id;
			if (t !== n[0] && r) {
				a(n);
				continue;
			}
		}
		if (e.metadataRegistry.get(n[0])?.id) {
			a(n);
			continue;
		}
		if (r.cycle) {
			a(n);
			continue;
		}
		if (r.count > 1 && e.reused === "ref") {
			a(n);
			continue;
		}
	}
}
function ii(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : Object.assign(i, s), Object.assign(i, a), t._zod.parent === o) for (let e in i) e === "$ref" || e === "allOf" || e in a || delete i[e];
			if (s.$ref && n.def) for (let e in i) e === "$ref" || e === "allOf" || e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e === "$ref" || e === "allOf" || e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	for (let t of [...e.seen.entries()].reverse()) r(t[0]);
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	Object.assign(i, n.def ?? n.schema);
	let a = e.external?.defs ?? {};
	for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (a[e.defId] = e.def);
	}
	e.external || Object.keys(a).length > 0 && (e.target === "draft-2020-12" ? i.$defs = a : i.definitions = a);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: oi(t, "input", e.processors),
					output: oi(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function F(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return F(r.element, n);
	if (r.type === "set") return F(r.valueType, n);
	if (r.type === "lazy") return F(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault") return F(r.innerType, n);
	if (r.type === "intersection") return F(r.left, n) || F(r.right, n);
	if (r.type === "record" || r.type === "map") return F(r.keyType, n) || F(r.valueType, n);
	if (r.type === "pipe") return F(r.in, n) || F(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (F(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (F(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (F(e, n)) return !0;
		return !!(r.rest && F(r.rest, n));
	}
	return !1;
}
var ai = (e, t = {}) => (n) => {
	let r = ni({
		...n,
		processors: t
	});
	return P(e, r), ri(r, e), ii(r, e);
}, oi = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = ni({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return P(e, o), ri(o, e), ii(o, e);
}, si = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, ci = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l } = e._zod.bag;
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = si[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c];
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, li = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, format: s, multipleOf: c, exclusiveMaximum: l, exclusiveMinimum: u } = e._zod.bag;
	typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = u, i.exclusiveMinimum = !0) : i.exclusiveMinimum = u), typeof a == "number" && (i.minimum = a, typeof u == "number" && t.target !== "draft-04" && (u >= a ? delete i.minimum : delete i.exclusiveMinimum)), typeof l == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l), typeof o == "number" && (i.maximum = o, typeof l == "number" && t.target !== "draft-04" && (l <= o ? delete i.maximum : delete i.exclusiveMaximum)), typeof c == "number" && (i.multipleOf = c);
}, ui = (e, t, n, r) => {
	n.type = "boolean";
}, di = (e, t, n, r) => {
	n.not = {};
}, fi = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Date cannot be represented in JSON Schema");
}, pi = (e, t, n, r) => {
	let i = e._zod.def, a = ee(i.entries);
	a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a;
}, mi = (e, t, n, r) => {
	let i = e._zod.def, a = [];
	for (let e of i.values) if (e === void 0) {
		if (t.unrepresentable === "throw") throw Error("Literal `undefined` cannot be represented in JSON Schema");
	} else if (typeof e == "bigint") {
		if (t.unrepresentable === "throw") throw Error("BigInt literals cannot be represented in JSON Schema");
		a.push(Number(e));
	} else a.push(e);
	if (a.length !== 0) if (a.length === 1) {
		let e = a[0];
		n.type = e === null ? "null" : typeof e, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [e] : n.const = e;
	} else a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), a.every((e) => typeof e == "boolean") && (n.type = "boolean"), a.every((e) => e === null) && (n.type = "null"), n.enum = a;
}, hi = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Custom types cannot be represented in JSON Schema");
}, gi = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Transforms cannot be represented in JSON Schema");
}, _i = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = e._zod.bag;
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = P(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
}, vi = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object", i.properties = {};
	let o = a.shape;
	for (let e in o) i.properties[e] = P(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	});
	let s = new Set(Object.keys(o)), c = new Set([...s].filter((e) => {
		let n = a.shape[e]._zod;
		return t.io === "input" ? n.optin === void 0 : n.optout === void 0;
	}));
	c.size > 0 && (i.required = Array.from(c)), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = P(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, yi = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => P(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, bi = (e, t, n, r) => {
	let i = e._zod.def, a = P(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = P(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1;
	n.allOf = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
}, xi = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object";
	let o = a.keyType, s = o._zod.bag?.patterns;
	if (a.mode === "loose" && s && s.size > 0) {
		let e = P(a.valueType, t, {
			...r,
			path: [
				...r.path,
				"patternProperties",
				"*"
			]
		});
		i.patternProperties = {};
		for (let t of s) i.patternProperties[t.source] = e;
	} else (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = P(a.keyType, t, {
		...r,
		path: [...r.path, "propertyNames"]
	})), i.additionalProperties = P(a.valueType, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	});
	let c = o._zod.values;
	if (c) {
		let e = [...c].filter((e) => typeof e == "string" || typeof e == "number");
		e.length > 0 && (i.required = e);
	}
}, Si = (e, t, n, r) => {
	let i = e._zod.def, a = P(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, Ci = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, wi = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Ti = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Ei = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		throw Error("Dynamic catch values are not supported in JSON Schema");
	}
	n.default = o;
}, Di = (e, t, n, r) => {
	let i = e._zod.def, a = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
	P(a, t, r);
	let o = t.seen.get(e);
	o.ref = a;
}, Oi = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, ki = (e, t, n, r) => {
	let i = e._zod.def;
	P(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Ai = (e, t, n, r) => {
	let i = e._zod.innerType;
	P(i, t, r);
	let a = t.seen.get(e);
	a.ref = i;
}, ji = /* @__PURE__ */ u("ZodISODateTime", (e, t) => {
	Jt.init(e, t), B.init(e, t);
});
function I(e) {
	return /* @__PURE__ */ Sr(ji, e);
}
var Mi = /* @__PURE__ */ u("ZodISODate", (e, t) => {
	Yt.init(e, t), B.init(e, t);
});
function Ni(e) {
	return /* @__PURE__ */ Cr(Mi, e);
}
var Pi = /* @__PURE__ */ u("ZodISOTime", (e, t) => {
	Xt.init(e, t), B.init(e, t);
});
function Fi(e) {
	return /* @__PURE__ */ wr(Pi, e);
}
var Ii = /* @__PURE__ */ u("ZodISODuration", (e, t) => {
	Zt.init(e, t), B.init(e, t);
});
function Li(e) {
	return /* @__PURE__ */ Tr(Ii, e);
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/classic/errors.js
var Ri = (e, t) => {
	we.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
		format: { value: (t) => De(e, t) },
		flatten: { value: (t) => Ee(e, t) },
		addIssue: { value: (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, te, 2);
		} },
		addIssues: { value: (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, te, 2);
		} },
		isEmpty: { get() {
			return e.issues.length === 0;
		} }
	});
};
u("ZodError", Ri);
var L = u("ZodError", Ri, { Parent: Error }), zi = /* @__PURE__ */ Oe(L), Bi = /* @__PURE__ */ ke(L), Vi = /* @__PURE__ */ Ae(L), Hi = /* @__PURE__ */ Me(L), Ui = /* @__PURE__ */ Pe(L), Wi = /* @__PURE__ */ Fe(L), Gi = /* @__PURE__ */ Ie(L), Ki = /* @__PURE__ */ Le(L), qi = /* @__PURE__ */ Re(L), Ji = /* @__PURE__ */ ze(L), Yi = /* @__PURE__ */ Be(L), Xi = /* @__PURE__ */ Ve(L), R = /* @__PURE__ */ u("ZodType", (e, t) => (k.init(e, t), Object.assign(e["~standard"], { jsonSchema: {
	input: oi(e, "input"),
	output: oi(e, "output")
} }), e.toJSONSchema = ai(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(_(t, { checks: [...t.checks ?? [], ...n.map((e) => typeof e == "function" ? { _zod: {
	check: e,
	def: { check: "custom" },
	onattach: []
} } : e)] }), { parent: !0 }), e.with = e.check, e.clone = (t, n) => x(e, t, n), e.brand = () => e, e.register = ((t, n) => (t.add(e, n), e)), e.parse = (t, n) => zi(e, t, n, { callee: e.parse }), e.safeParse = (t, n) => Vi(e, t, n), e.parseAsync = async (t, n) => Bi(e, t, n, { callee: e.parseAsync }), e.safeParseAsync = async (t, n) => Hi(e, t, n), e.spa = e.safeParseAsync, e.encode = (t, n) => Ui(e, t, n), e.decode = (t, n) => Wi(e, t, n), e.encodeAsync = async (t, n) => Gi(e, t, n), e.decodeAsync = async (t, n) => Ki(e, t, n), e.safeEncode = (t, n) => qi(e, t, n), e.safeDecode = (t, n) => Ji(e, t, n), e.safeEncodeAsync = async (t, n) => Yi(e, t, n), e.safeDecodeAsync = async (t, n) => Xi(e, t, n), e.refine = (t, n) => e.check(lo(t, n)), e.superRefine = (t) => e.check(uo(t)), e.overwrite = (t) => e.check(/* @__PURE__ */ N(t)), e.optional = () => Ha(e), e.exactOptional = () => Wa(e), e.nullable = () => Ka(e), e.nullish = () => Ha(Ka(e)), e.nonoptional = (t) => Qa(e, t), e.array = () => G(e), e.or = (t) => ka([e, t]), e.and = (t) => Na(e, t), e.transform = (t) => no(e, Ba(t)), e.default = (t) => Ja(e, t), e.prefault = (t) => Xa(e, t), e.catch = (t) => eo(e, t), e.pipe = (t) => no(e, t), e.readonly = () => io(e), e.describe = (t) => {
	let n = e.clone();
	return j.add(n, { description: t }), n;
}, Object.defineProperty(e, "description", {
	get() {
		return j.get(e)?.description;
	},
	configurable: !0
}), e.meta = (...t) => {
	if (t.length === 0) return j.get(e);
	let n = e.clone();
	return j.add(n, t[0]), n;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (t) => t(e), e)), Zi = /* @__PURE__ */ u("_ZodString", (e, t) => {
	It.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => ci(e, t, n, r);
	let n = e._zod.bag;
	e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...t) => e.check(/* @__PURE__ */ Br(...t)), e.includes = (...t) => e.check(/* @__PURE__ */ Ur(...t)), e.startsWith = (...t) => e.check(/* @__PURE__ */ Wr(...t)), e.endsWith = (...t) => e.check(/* @__PURE__ */ Gr(...t)), e.min = (...t) => e.check(/* @__PURE__ */ M(...t)), e.max = (...t) => e.check(/* @__PURE__ */ Rr(...t)), e.length = (...t) => e.check(/* @__PURE__ */ zr(...t)), e.nonempty = (...t) => e.check(/* @__PURE__ */ M(1, ...t)), e.lowercase = (t) => e.check(/* @__PURE__ */ Vr(t)), e.uppercase = (t) => e.check(/* @__PURE__ */ Hr(t)), e.trim = () => e.check(/* @__PURE__ */ qr()), e.normalize = (...t) => e.check(/* @__PURE__ */ Kr(...t)), e.toLowerCase = () => e.check(/* @__PURE__ */ Jr()), e.toUpperCase = () => e.check(/* @__PURE__ */ Yr()), e.slugify = () => e.check(/* @__PURE__ */ Xr());
}), Qi = /* @__PURE__ */ u("ZodString", (e, t) => {
	It.init(e, t), Zi.init(e, t), e.email = (t) => e.check(/* @__PURE__ */ er($i, t)), e.url = (t) => e.check(/* @__PURE__ */ or(na, t)), e.jwt = (t) => e.check(/* @__PURE__ */ xr(_a, t)), e.emoji = (t) => e.check(/* @__PURE__ */ sr(ra, t)), e.guid = (t) => e.check(/* @__PURE__ */ tr(ea, t)), e.uuid = (t) => e.check(/* @__PURE__ */ nr(ta, t)), e.uuidv4 = (t) => e.check(/* @__PURE__ */ rr(ta, t)), e.uuidv6 = (t) => e.check(/* @__PURE__ */ ir(ta, t)), e.uuidv7 = (t) => e.check(/* @__PURE__ */ ar(ta, t)), e.nanoid = (t) => e.check(/* @__PURE__ */ cr(ia, t)), e.guid = (t) => e.check(/* @__PURE__ */ tr(ea, t)), e.cuid = (t) => e.check(/* @__PURE__ */ lr(aa, t)), e.cuid2 = (t) => e.check(/* @__PURE__ */ ur(oa, t)), e.ulid = (t) => e.check(/* @__PURE__ */ dr(sa, t)), e.base64 = (t) => e.check(/* @__PURE__ */ vr(ma, t)), e.base64url = (t) => e.check(/* @__PURE__ */ yr(ha, t)), e.xid = (t) => e.check(/* @__PURE__ */ fr(ca, t)), e.ksuid = (t) => e.check(/* @__PURE__ */ pr(la, t)), e.ipv4 = (t) => e.check(/* @__PURE__ */ mr(ua, t)), e.ipv6 = (t) => e.check(/* @__PURE__ */ hr(da, t)), e.cidrv4 = (t) => e.check(/* @__PURE__ */ gr(fa, t)), e.cidrv6 = (t) => e.check(/* @__PURE__ */ _r(pa, t)), e.e164 = (t) => e.check(/* @__PURE__ */ br(ga, t)), e.datetime = (t) => e.check(I(t)), e.date = (t) => e.check(Ni(t)), e.time = (t) => e.check(Fi(t)), e.duration = (t) => e.check(Li(t));
});
function z(e) {
	return /* @__PURE__ */ $n(Qi, e);
}
var B = /* @__PURE__ */ u("ZodStringFormat", (e, t) => {
	A.init(e, t), Zi.init(e, t);
}), $i = /* @__PURE__ */ u("ZodEmail", (e, t) => {
	zt.init(e, t), B.init(e, t);
}), ea = /* @__PURE__ */ u("ZodGUID", (e, t) => {
	Lt.init(e, t), B.init(e, t);
}), ta = /* @__PURE__ */ u("ZodUUID", (e, t) => {
	Rt.init(e, t), B.init(e, t);
}), na = /* @__PURE__ */ u("ZodURL", (e, t) => {
	Bt.init(e, t), B.init(e, t);
}), ra = /* @__PURE__ */ u("ZodEmoji", (e, t) => {
	Vt.init(e, t), B.init(e, t);
}), ia = /* @__PURE__ */ u("ZodNanoID", (e, t) => {
	Ht.init(e, t), B.init(e, t);
}), aa = /* @__PURE__ */ u("ZodCUID", (e, t) => {
	Ut.init(e, t), B.init(e, t);
}), oa = /* @__PURE__ */ u("ZodCUID2", (e, t) => {
	Wt.init(e, t), B.init(e, t);
}), sa = /* @__PURE__ */ u("ZodULID", (e, t) => {
	Gt.init(e, t), B.init(e, t);
}), ca = /* @__PURE__ */ u("ZodXID", (e, t) => {
	Kt.init(e, t), B.init(e, t);
}), la = /* @__PURE__ */ u("ZodKSUID", (e, t) => {
	qt.init(e, t), B.init(e, t);
}), ua = /* @__PURE__ */ u("ZodIPv4", (e, t) => {
	Qt.init(e, t), B.init(e, t);
}), da = /* @__PURE__ */ u("ZodIPv6", (e, t) => {
	$t.init(e, t), B.init(e, t);
}), fa = /* @__PURE__ */ u("ZodCIDRv4", (e, t) => {
	en.init(e, t), B.init(e, t);
}), pa = /* @__PURE__ */ u("ZodCIDRv6", (e, t) => {
	tn.init(e, t), B.init(e, t);
}), ma = /* @__PURE__ */ u("ZodBase64", (e, t) => {
	rn.init(e, t), B.init(e, t);
}), ha = /* @__PURE__ */ u("ZodBase64URL", (e, t) => {
	on.init(e, t), B.init(e, t);
}), ga = /* @__PURE__ */ u("ZodE164", (e, t) => {
	sn.init(e, t), B.init(e, t);
}), _a = /* @__PURE__ */ u("ZodJWT", (e, t) => {
	ln.init(e, t), B.init(e, t);
}), va = /* @__PURE__ */ u("ZodNumber", (e, t) => {
	un.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => li(e, t, n, r), e.gt = (t, n) => e.check(/* @__PURE__ */ Fr(t, n)), e.gte = (t, n) => e.check(/* @__PURE__ */ Ir(t, n)), e.min = (t, n) => e.check(/* @__PURE__ */ Ir(t, n)), e.lt = (t, n) => e.check(/* @__PURE__ */ Nr(t, n)), e.lte = (t, n) => e.check(/* @__PURE__ */ Pr(t, n)), e.max = (t, n) => e.check(/* @__PURE__ */ Pr(t, n)), e.int = (t) => e.check(ba(t)), e.safe = (t) => e.check(ba(t)), e.positive = (t) => e.check(/* @__PURE__ */ Fr(0, t)), e.nonnegative = (t) => e.check(/* @__PURE__ */ Ir(0, t)), e.negative = (t) => e.check(/* @__PURE__ */ Nr(0, t)), e.nonpositive = (t) => e.check(/* @__PURE__ */ Pr(0, t)), e.multipleOf = (t, n) => e.check(/* @__PURE__ */ Lr(t, n)), e.step = (t, n) => e.check(/* @__PURE__ */ Lr(t, n)), e.finite = () => e;
	let n = e._zod.bag;
	e.minValue = Math.max(n.minimum ?? -Infinity, n.exclusiveMinimum ?? -Infinity) ?? null, e.maxValue = Math.min(n.maximum ?? Infinity, n.exclusiveMaximum ?? Infinity) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? .5), e.isFinite = !0, e.format = n.format ?? null;
});
function V(e) {
	return /* @__PURE__ */ Er(va, e);
}
var ya = /* @__PURE__ */ u("ZodNumberFormat", (e, t) => {
	dn.init(e, t), va.init(e, t);
});
function ba(e) {
	return /* @__PURE__ */ Or(ya, e);
}
var xa = /* @__PURE__ */ u("ZodBoolean", (e, t) => {
	fn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => ui(e, t, n, r);
});
function H(e) {
	return /* @__PURE__ */ kr(xa, e);
}
var Sa = /* @__PURE__ */ u("ZodUnknown", (e, t) => {
	pn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function U() {
	return /* @__PURE__ */ Ar(Sa);
}
var Ca = /* @__PURE__ */ u("ZodNever", (e, t) => {
	mn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => di(e, t, n, r);
});
function wa(e) {
	return /* @__PURE__ */ jr(Ca, e);
}
var Ta = /* @__PURE__ */ u("ZodDate", (e, t) => {
	hn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => fi(e, t, n, r), e.min = (t, n) => e.check(/* @__PURE__ */ Ir(t, n)), e.max = (t, n) => e.check(/* @__PURE__ */ Pr(t, n));
	let n = e._zod.bag;
	e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function W(e) {
	return /* @__PURE__ */ Mr(Ta, e);
}
var Ea = /* @__PURE__ */ u("ZodArray", (e, t) => {
	_n.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => _i(e, t, n, r), e.element = t.element, e.min = (t, n) => e.check(/* @__PURE__ */ M(t, n)), e.nonempty = (t) => e.check(/* @__PURE__ */ M(1, t)), e.max = (t, n) => e.check(/* @__PURE__ */ Rr(t, n)), e.length = (t, n) => e.check(/* @__PURE__ */ zr(t, n)), e.unwrap = () => e.element;
});
function G(e, t) {
	return /* @__PURE__ */ Zr(Ea, e, t);
}
var Da = /* @__PURE__ */ u("ZodObject", (e, t) => {
	Sn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => vi(e, t, n, r), h(e, "shape", () => t.shape), e.keyof = () => J(Object.keys(e._zod.def.shape)), e.catchall = (t) => e.clone({
		...e._zod.def,
		catchall: t
	}), e.passthrough = () => e.clone({
		...e._zod.def,
		catchall: U()
	}), e.loose = () => e.clone({
		...e._zod.def,
		catchall: U()
	}), e.strict = () => e.clone({
		...e._zod.def,
		catchall: wa()
	}), e.strip = () => e.clone({
		...e._zod.def,
		catchall: void 0
	}), e.extend = (t) => _e(e, t), e.safeExtend = (t) => ve(e, t), e.merge = (t) => ye(e, t), e.pick = (t) => he(e, t), e.omit = (t) => ge(e, t), e.partial = (...t) => be(Va, e, t[0]), e.required = (...t) => xe(Za, e, t[0]);
});
function K(e, t) {
	return new Da({
		type: "object",
		shape: e ?? {},
		...S(t)
	});
}
var Oa = /* @__PURE__ */ u("ZodUnion", (e, t) => {
	wn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => yi(e, t, n, r), e.options = t.options;
});
function ka(e, t) {
	return new Oa({
		type: "union",
		options: e,
		...S(t)
	});
}
var Aa = /* @__PURE__ */ u("ZodDiscriminatedUnion", (e, t) => {
	Oa.init(e, t), Tn.init(e, t);
});
function ja(e, t, n) {
	return new Aa({
		type: "union",
		options: t,
		discriminator: e,
		...S(n)
	});
}
var Ma = /* @__PURE__ */ u("ZodIntersection", (e, t) => {
	En.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => bi(e, t, n, r);
});
function Na(e, t) {
	return new Ma({
		type: "intersection",
		left: e,
		right: t
	});
}
var Pa = /* @__PURE__ */ u("ZodRecord", (e, t) => {
	kn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => xi(e, t, n, r), e.keyType = t.keyType, e.valueType = t.valueType;
});
function q(e, t, n) {
	return new Pa({
		type: "record",
		keyType: e,
		valueType: t,
		...S(n)
	});
}
var Fa = /* @__PURE__ */ u("ZodEnum", (e, t) => {
	An.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => pi(e, t, n, r), e.enum = t.entries, e.options = Object.values(t.entries);
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new Fa({
			...t,
			checks: [],
			...S(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new Fa({
			...t,
			checks: [],
			...S(r),
			entries: i
		});
	};
});
function J(e, t) {
	return new Fa({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...S(t)
	});
}
function Ia(e, t) {
	return new Fa({
		type: "enum",
		entries: e,
		...S(t)
	});
}
var La = /* @__PURE__ */ u("ZodLiteral", (e, t) => {
	jn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => mi(e, t, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
		if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
		return t.values[0];
	} });
});
function Ra(e, t) {
	return new La({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...S(t)
	});
}
var za = /* @__PURE__ */ u("ZodTransform", (e, t) => {
	Mn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => gi(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new f(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(D(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", t.input ??= n.value, t.inst ??= e, n.issues.push(D(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n)) : (n.value = i, n);
	};
});
function Ba(e) {
	return new za({
		type: "transform",
		transform: e
	});
}
var Va = /* @__PURE__ */ u("ZodOptional", (e, t) => {
	Pn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => ki(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Ha(e) {
	return new Va({
		type: "optional",
		innerType: e
	});
}
var Ua = /* @__PURE__ */ u("ZodExactOptional", (e, t) => {
	Fn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => ki(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Wa(e) {
	return new Ua({
		type: "optional",
		innerType: e
	});
}
var Ga = /* @__PURE__ */ u("ZodNullable", (e, t) => {
	In.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Si(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Ka(e) {
	return new Ga({
		type: "nullable",
		innerType: e
	});
}
var qa = /* @__PURE__ */ u("ZodDefault", (e, t) => {
	Ln.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => wi(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Ja(e, t) {
	return new qa({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : de(t);
		}
	});
}
var Ya = /* @__PURE__ */ u("ZodPrefault", (e, t) => {
	zn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ti(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Xa(e, t) {
	return new Ya({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : de(t);
		}
	});
}
var Za = /* @__PURE__ */ u("ZodNonOptional", (e, t) => {
	Bn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ci(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Qa(e, t) {
	return new Za({
		type: "nonoptional",
		innerType: e,
		...S(t)
	});
}
var $a = /* @__PURE__ */ u("ZodCatch", (e, t) => {
	Hn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ei(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function eo(e, t) {
	return new $a({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : () => t
	});
}
var to = /* @__PURE__ */ u("ZodPipe", (e, t) => {
	Un.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Di(e, t, n, r), e.in = t.in, e.out = t.out;
});
function no(e, t) {
	return new to({
		type: "pipe",
		in: e,
		out: t
	});
}
var ro = /* @__PURE__ */ u("ZodReadonly", (e, t) => {
	Gn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Oi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function io(e) {
	return new ro({
		type: "readonly",
		innerType: e
	});
}
var ao = /* @__PURE__ */ u("ZodLazy", (e, t) => {
	qn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ai(e, t, n, r), e.unwrap = () => e._zod.def.getter();
});
function oo(e) {
	return new ao({
		type: "lazy",
		getter: e
	});
}
var so = /* @__PURE__ */ u("ZodCustom", (e, t) => {
	Jn.init(e, t), R.init(e, t), e._zod.processJSONSchema = (t, n, r) => hi(e, t, n, r);
});
function co(e, t) {
	return /* @__PURE__ */ Qr(so, e ?? (() => !0), t);
}
function lo(e, t = {}) {
	return /* @__PURE__ */ $r(so, e, t);
}
function uo(e) {
	return /* @__PURE__ */ ei(e);
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.3.6/node_modules/zod/v4/classic/coerce.js
function Y(e) {
	return /* @__PURE__ */ Dr(va, e);
}
//#endregion
//#region src/domain/schemas.ts
var fo = K({
	id: z(),
	email: z(),
	emailVerified: H(),
	firstName: z().nullable(),
	lastName: z().nullable(),
	avatarUrl: z().nullable(),
	createdAt: z(),
	updatedAt: z()
}), po = K({
	id: z(),
	name: z(),
	logoUrl: z().nullable(),
	createdAt: z(),
	updatedAt: z()
}), mo = K({
	slug: z(),
	name: z()
}), ho = K({
	id: z(),
	userId: z(),
	organizationId: z(),
	organizationName: z(),
	role: mo.nullable(),
	status: J(c),
	logoUrl: z().nullable()
}), go = co((e) => typeof e == "string"), _o = K({
	user: fo,
	organizationId: z().nullable(),
	organizations: G(ho),
	role: mo.nullable(),
	permissions: G(go).nullable(),
	avatarUrl: z().nullable()
}), vo = K({
	id: z(),
	email: z(),
	organizationId: z(),
	inviterId: z(),
	token: z(),
	state: J(l),
	acceptedAt: W().nullable(),
	revokedAt: W().nullable(),
	expiresAt: W(),
	createdAt: W()
}), yo = /* @__PURE__ */ function(e) {
	return e.SUPER_ADMIN = "super_admin", e.ADMIN = "admin", e;
}({}), bo = Ia(yo), xo = K({
	user: fo,
	role: bo
}), So = K({
	id: z(),
	email: z(),
	userId: z().nullable(),
	role: bo,
	note: z().nullable(),
	createdAt: z()
}), Co = K({
	date: z(),
	count: V()
}), wo = K({
	organizationCount: V(),
	adminCount: V(),
	signups: G(Co),
	recentUsers: G(fo)
}), X = /* @__PURE__ */ function(e) {
	return e.ALL = "all", e.ORGANIZATION = "organization", e.USERS = "users", e;
}({}), To = /* @__PURE__ */ function(e) {
	return e.SENDING = "sending", e.SENT = "sent", e.FAILED = "failed", e;
}({}), Eo = /* @__PURE__ */ function(e) {
	return e.APP = "app", e.EMAIL = "email", e;
}({}), Do = Ia(Eo), Oo = Ia(X), ko = Ia(To), Ao = K({
	id: z().min(1),
	email: z().email()
}), jo = ja("type", [
	K({ type: Ra(X.ALL) }),
	K({
		type: Ra(X.ORGANIZATION),
		organizationId: z().min(1)
	}),
	K({
		type: Ra(X.USERS),
		recipients: G(Ao).min(1)
	})
]), Mo = K({
	type: z().min(1).max(128),
	title: z().min(1).max(200),
	body: z().max(2e3).default(""),
	metadata: q(z(), U()).optional(),
	channels: G(Do).min(1),
	audience: jo
}).refine((e) => !e.channels.includes(Eo.EMAIL) || e.audience.type === X.USERS, {
	message: "Email delivery is only available when specific users are selected",
	path: ["channels"]
}), No = K({
	id: z().uuid(),
	actorId: z(),
	actorEmail: z(),
	type: z(),
	title: z(),
	body: z(),
	metadata: q(z(), U()),
	channels: G(Do),
	audienceType: Oo,
	audienceOrganizationId: z().nullable(),
	audienceUserIds: G(z()),
	recipientCount: V().int().min(0),
	readCount: V().int().min(0),
	readRate: V().min(0).max(1),
	emailSentCount: V().int().min(0),
	status: ko,
	createdAt: z(),
	updatedAt: z()
}), Po = K({
	recipientCount: V().int().min(0),
	readCount: V().int().min(0),
	readRate: V().min(0).max(1),
	emailSentCount: V().int().min(0)
}), Fo = K({
	limit: Y().int().positive().max(100).optional(),
	after: z().optional()
}), Io = K({
	date: z(),
	app: V().int().min(0),
	email: V().int().min(0)
}), Lo = K({
	totalCampaigns: V().int().min(0),
	totalRecipients: V().int().min(0),
	averageReadRate: V().min(0).max(1),
	sends: G(Io)
}), Z = /* @__PURE__ */ function(e) {
	return e.FLASH_NOTE = "flash_note", e.COMPANY_NOTE = "company_note", e.SECTOR_NOTE = "sector_note", e.INITIATION_NOTE = "initiation_note", e.OTHER = "other", e;
}({}), Ro = /* @__PURE__ */ function(e) {
	return e.UPLOADED = "uploaded", e.PARSING = "parsing", e.PARSED = "parsed", e.EXTRACTING = "extracting", e.INDEXING = "indexing", e.READY = "ready", e.FAILED = "failed", e.SUPERSEDED = "superseded", e;
}({}), zo = /* @__PURE__ */ function(e) {
	return e.UPLOAD = "upload", e.EMAIL = "email", e.S3 = "s3", e.API = "api", e;
}({}), Bo = /* @__PURE__ */ function(e) {
	return e.RECEIVE = "receive", e.PARSE_LAYOUT = "parse.layout", e.PARSE_QUALITY_GATE = "parse.quality-gate", e.PARSE_VISION_FALLBACK = "parse.vision-fallback", e.STRUCTURE = "structure", e.CLASSIFY_METADATA = "classify.metadata", e.EXTRACT_FRONT_PAGE = "extract.front-page", e.CHUNK = "chunk", e.EMBED = "embed", e.SYNTHESIZE_LAYERS = "synthesize.layers", e.PUBLISH = "publish", e;
}({}), Vo = /* @__PURE__ */ function(e) {
	return e.PENDING = "pending", e.RUNNING = "running", e.SUCCEEDED = "succeeded", e.FAILED = "failed", e.SKIPPED = "skipped", e;
}({}), Ho = /* @__PURE__ */ function(e) {
	return e.DOCLING = "docling", e.BEDROCK_BDA = "bedrock_bda", e.AZURE_DI = "azure_di", e.VISION_LLM = "vision_llm", e;
}({}), Uo = /* @__PURE__ */ function(e) {
	return e.TITLE = "title", e.SECTION_HEADING = "section_heading", e.PARAGRAPH = "paragraph", e.LIST = "list", e.TABLE = "table", e.FIGURE = "figure", e.CAPTION = "caption", e.HEADER = "header", e.FOOTER = "footer", e.FOOTNOTE = "footnote", e.PAGE_NUMBER = "page_number", e;
}({}), Wo = /* @__PURE__ */ function(e) {
	return e.FRONT_PAGE = "front_page", e.BODY = "body", e.TABLE = "table", e.FIGURE = "figure", e.NOTE_SUMMARY = "note_summary", e;
}({}), Go = /* @__PURE__ */ function(e) {
	return e.BUY = "buy", e.HOLD = "hold", e.SELL = "sell", e.NOT_RATED = "not_rated", e.UNKNOWN = "unknown", e;
}({}), Ko = /* @__PURE__ */ function(e) {
	return e.INITIATE = "initiate", e.UPGRADE = "upgrade", e.DOWNGRADE = "downgrade", e.REITERATE = "reiterate", e.NONE = "none", e;
}({}), qo = /* @__PURE__ */ function(e) {
	return e.INITIATE = "initiate", e.RAISE = "raise", e.CUT = "cut", e.MAINTAIN = "maintain", e.NONE = "none", e;
}({}), Jo = /* @__PURE__ */ function(e) {
	return e.AUTO = "auto", e.REVIEWED = "reviewed", e.REJECTED = "rejected", e;
}({}), Yo = /* @__PURE__ */ function(e) {
	return e.PRIMARY = "primary", e.MENTIONED = "mentioned", e;
}({}), Xo = /* @__PURE__ */ function(e) {
	return e.NOTE_FIELD = "note_field", e.NOTE_LAYER = "note_layer", e.ANSWER = "answer", e.CHUNK = "chunk", e.CLASSIFICATION = "classification", e.BLOCK = "block", e;
}({}), Zo = /* @__PURE__ */ function(e) {
	return e.CORRECT = "correct", e.INCORRECT = "incorrect", e.PARTIAL = "partial", e;
}({}), Qo = /* @__PURE__ */ function(e) {
	return e.DOCUMENT = "document", e.BROKER = "broker", e.DOC_TYPE = "doc_type", e.GLOBAL = "global", e;
}({}), $o = /* @__PURE__ */ function(e) {
	return e.NEW = "new", e.APPLIED = "applied", e.LESSON_CREATED = "lesson_created", e.EVAL_CASE_CREATED = "eval_case_created", e.TEMPLATE_UPDATED = "template_updated", e.DISMISSED = "dismissed", e;
}({}), es = /* @__PURE__ */ function(e) {
	return e.PROPOSED = "proposed", e.ACTIVE = "active", e.RETIRED = "retired", e.FOLDED_INTO_TEMPLATE = "folded_into_template", e;
}({}), ts = /* @__PURE__ */ function(e) {
	return e.REST = "rest", e.MCP_INTERNAL = "mcp_internal", e.MCP_EXTERNAL = "mcp_external", e.WORKER = "worker", e;
}({}), ns = /* @__PURE__ */ function(e) {
	return e.USER = "user", e.API_CLIENT = "api_client", e.SYSTEM = "system", e.PLATFORM_ADMIN = "platform_admin", e;
}({}), rs = /* @__PURE__ */ function(e) {
	return e.SEARCH = "search", e.ANSWER = "answer", e.GET_NOTE = "get_note", e.GET_DOCUMENT = "get_document", e.GET_PAGE_RENDER = "get_page_render", e.INGEST = "ingest", e.REPROCESS = "reprocess", e.MODEL_CALL = "model_call", e.EXPORT = "export", e.FEEDBACK = "feedback", e.DELETE_DOCUMENT = "delete_document", e.API_KEY_CREATE = "api_key_create", e.API_KEY_REVOKE = "api_key_revoke", e.AI_POLICY_UPDATE = "ai_policy_update", e.LESSON_UPDATE = "lesson_update", e.MEMBER_INVITE = "member_invite", e.MEMBER_ROLE_CHANGE = "member_role_change", e.MEMBER_REMOVE = "member_remove", e.ORGANIZATION_UPDATE = "organization_update", e.ORGANIZATION_DELETE = "organization_delete", e.LOGIN = "login", e.LOGOUT = "logout", e.MEMBER_JOIN = "member_join", e.INVITATION_RESEND = "invitation_resend", e.INVITATION_CANCEL = "invitation_cancel", e.AUDIT_EXPORT = "audit_export", e.AI_CONNECTION_CREATE = "ai_connection_create", e.AI_CONNECTION_UPDATE = "ai_connection_update", e.AI_CONNECTION_DELETE = "ai_connection_delete", e.AI_CONNECTION_TEST = "ai_connection_test", e.AI_MODEL_BIND = "ai_model_bind", e;
}({}), is = /* @__PURE__ */ function(e) {
	return e.OPENAI = "openai", e.ANTHROPIC = "anthropic", e.OPENAI_COMPATIBLE = "openai_compatible", e;
}({}), as = /* @__PURE__ */ function(e) {
	return e.UNTESTED = "untested", e.OK = "ok", e.FAILED = "failed", e;
}({}), Q = /* @__PURE__ */ function(e) {
	return e.CLASSIFY = "classify", e.EXTRACT = "extract", e.SYNTHESIZE = "synthesize", e.EMBED = "embed", e.RERANK = "rerank", e.ANSWER = "answer", e.VISION_PARSE = "vision_parse", e.QUERY_UNDERSTANDING = "query_understanding", e;
}({}), os = /* @__PURE__ */ function(e) {
	return e.ZERO_RETENTION = "zero_retention", e.PROVIDER_DEFAULT = "provider_default", e;
}({}), ss = /* @__PURE__ */ function(e) {
	return e.ALLOW = "allow", e.NONE = "none", e;
}({}), cs = /* @__PURE__ */ function(e) {
	return e.FULL = "full", e.HASH_ONLY = "hash_only", e;
}({}), ls = /* @__PURE__ */ function(e) {
	return e.RETRIEVE = "retrieve", e.ANSWER = "answer", e;
}({}), us = /* @__PURE__ */ function(e) {
	return e.STRUCTURED = "structured", e.SEMANTIC = "semantic", e;
}({}), ds = /* @__PURE__ */ function(e) {
	return e.SPAN = "span", e.DERIVED = "derived", e;
}({}), fs = K({
	x0: V(),
	y0: V(),
	x1: V(),
	y1: V()
}), $ = oo(() => K({
	documentId: z(),
	page: V().int().positive(),
	blockIds: G(z()),
	spanIds: G(z()),
	quote: z(),
	rects: G(fs),
	kind: J(ds),
	derivedFrom: K({
		formula: z(),
		inputs: G($)
	}).optional(),
	viewerUrl: z()
})), ps = K({
	tickers: G(z().min(1).max(16)).max(50).optional(),
	brokerIds: G(z().uuid()).max(50).optional(),
	docTypes: G(J(Z)).optional(),
	publishedFrom: I().optional(),
	publishedTo: I().optional(),
	kinds: G(J(Wo)).optional(),
	documentIds: G(z().uuid()).max(100).optional(),
	pageFrom: V().int().min(1).optional(),
	pageTo: V().int().min(1).optional()
}), ms = K({
	query: z().min(1).max(2e3),
	filters: ps.optional(),
	mode: J(ls).default(ls.RETRIEVE),
	topK: V().int().min(1).max(50).default(8),
	rerank: H().optional(),
	askId: z().uuid().optional()
}), hs = K({
	chunkId: z(),
	documentId: z(),
	documentTitle: z().nullable(),
	brokerName: z().nullable(),
	publishedAt: z().nullable(),
	page: V().int(),
	pageEnd: V().int(),
	sectionPath: G(z()),
	kind: J(Wo),
	content: z(),
	score: V(),
	source: J([
		"vector",
		"fts",
		"both",
		"exact"
	]),
	citation: $
}), gs = K({
	documentId: z(),
	documentTitle: z().nullable(),
	page: V().int(),
	table: z().nullable(),
	row: z(),
	cells: G(K({
		column: z(),
		value: z(),
		citation: $
	}))
}), _s = K({
	route: J(us),
	notes: oo(() => G(Os)).optional(),
	chunks: G(hs),
	tableHits: G(gs).optional(),
	answer: K({
		text: z(),
		claims: G(K({
			text: z(),
			citations: G($)
		}))
	}).optional(),
	audit: K({
		eventId: z(),
		latencyMs: V()
	}),
	askId: z().optional()
}), vs = K({
	documentId: z().uuid().optional(),
	before: I().optional(),
	limit: Y().int().min(1).max(100).default(30)
}), ys = K({
	id: z(),
	query: z(),
	mode: J(ls),
	documentId: z().nullable(),
	documentTitle: z().nullable(),
	createdAt: z(),
	answer: z().nullable(),
	passages: V().int(),
	tableFigures: V().int(),
	redacted: H()
}), bs = ys.extend({
	filters: ps,
	response: _s
}), xs = K({ documentId: z().uuid().optional() }), Ss = K({
	id: z(),
	status: J(Ro),
	docType: J(Z).nullable(),
	title: z().nullable(),
	originalFilename: z(),
	pageCount: V().int().nullable(),
	publishedAt: z().nullable(),
	receivedAt: z(),
	brokerName: z().nullable(),
	tickers: G(z()),
	error: z().nullable()
}), Cs = K({
	step: J(Bo),
	status: J(Vo),
	attempt: V().int(),
	implementationVersion: z(),
	provider: z().nullable(),
	startedAt: z().nullable(),
	finishedAt: z().nullable(),
	error: z().nullable(),
	metrics: q(z(), U())
}), ws = K({
	status: J(Ro).optional(),
	docType: J(Z).optional(),
	ticker: z().max(16).optional(),
	publishedFrom: I().optional(),
	publishedTo: I().optional(),
	limit: Y().int().min(1).max(100).default(25),
	offset: Y().int().min(0).default(0)
}), Ts = K({ from: J(Bo).default(Bo.PARSE_LAYOUT) }), Es = K({
	highlight: z().max(4e3).optional(),
	size: J(["thumbnail", "full"]).default("full")
}), Ds = K({
	documentId: z(),
	page: V().int(),
	width: V(),
	height: V(),
	imageUrl: z().nullable(),
	rects: G(fs),
	spanIds: G(z())
}), Os = K({
	id: z(),
	documentId: z(),
	docType: J(Z).nullable(),
	brokerName: z().nullable(),
	ticker: z().nullable(),
	instrumentName: z().nullable(),
	leadAnalyst: z().nullable(),
	publishedAt: z().nullable(),
	ratingRaw: z().nullable(),
	rating: J(Go).nullable(),
	ratingAction: J(Ko).nullable(),
	priceTarget: V().nullable(),
	priceTargetCurrency: z().nullable(),
	priceTargetAction: J(qo).nullable(),
	sharePrice: V().nullable(),
	impliedReturn: V().nullable(),
	headline: z().nullable(),
	reviewStatus: J(Jo)
}), ks = K({
	title: z(),
	body: z(),
	citations: G($).default([])
}), As = Os.extend({
	keyTakeawayVerbatim: z().nullable(),
	keyPoints: G(ks),
	valuation: q(z(), U()),
	estimates: q(z(), U()),
	changesVsPrevious: q(z(), U()),
	fieldConfidence: q(z(), V()),
	provenance: q(z(), $)
}), js = K({
	from: I().optional(),
	to: I().optional(),
	tickers: z().max(400).optional().describe("Comma-separated tickers"),
	docTypes: z().max(200).optional().describe("Comma-separated doc types"),
	ratingActions: z().max(200).optional().describe("Comma-separated rating actions"),
	limit: Y().int().min(1).max(100).default(50),
	offset: Y().int().min(0).default(0)
}), Ms = K({
	documentId: z().uuid().optional(),
	targetType: J(Xo),
	targetId: z().max(128).optional().describe("Note id, chunk id or answer audit id"),
	field: z().max(64).optional().describe("Field name for note_field feedback, e.g. priceTargetCurrency"),
	verdict: J(Zo),
	actual: U().optional(),
	expected: U().optional(),
	rationale: z().min(1).max(4e3).describe("The 'because…' — required; this is what becomes a lesson"),
	scope: J(Qo).default(Qo.DOCUMENT)
}), Ns = K({ fields: G(z().min(1).max(64)).min(1).max(32).optional() }), Ps = K({
	noteId: z(),
	confirmed: G(z()),
	reviewStatus: J(Jo)
}), Fs = K({
	feedbackId: z(),
	status: J($o),
	lessonId: z().nullable(),
	notePatched: H()
}), Is = K({
	pageNumber: V().int(),
	width: V(),
	height: V(),
	isFrontPage: H(),
	isBoilerplate: H(),
	needsFallback: H(),
	thumbnailUrl: z().nullable()
}), Ls = K({
	documents: K({
		total: V(),
		ready: V(),
		processing: V(),
		failed: V()
	}),
	pages: V(),
	chunks: V(),
	notes: K({
		total: V(),
		awaitingReview: V(),
		reviewed: V()
	}),
	withoutNote: K({
		total: V(),
		byDocType: G(K({
			docType: z().nullable(),
			count: V()
		}))
	}),
	lessons: V(),
	lastReceivedAt: z().nullable()
}), Rs = Os.extend({
	documentTitle: z().nullable(),
	minConfidence: V().nullable(),
	weakFields: G(z())
}), zs = K({
	id: z(),
	documentId: z().nullable(),
	documentTitle: z().nullable(),
	authorId: z(),
	targetType: J(Xo),
	field: z().nullable(),
	verdict: J(Zo),
	actual: U().nullable(),
	expected: U().nullable(),
	rationale: z(),
	scope: J(Qo),
	status: J($o),
	lessonId: z().nullable(),
	createdAt: z()
}), Bs = K({
	id: z(),
	isGlobal: H(),
	title: z(),
	instruction: z(),
	pitfallExample: q(z(), U()).nullable(),
	appliesTo: q(z(), U()),
	status: J(es),
	createdBy: z(),
	createdAt: z()
}), Vs = K({ status: J([es.ACTIVE, es.RETIRED]) }), Hs = {
	action: J(rs).optional(),
	surface: J(ts).optional(),
	actorId: z().max(128).optional(),
	resourceId: z().max(128).optional(),
	from: z().max(40).optional(),
	to: z().max(40).optional()
}, Us = K({
	...Hs,
	limit: Y().int().min(1).max(200).default(50),
	offset: Y().int().min(0).default(0)
}), Ws = K(Hs), Gs = K({
	id: z(),
	actorType: J(ns),
	actorId: z().nullable(),
	actorLabel: z().nullable(),
	surface: J(ts),
	action: z(),
	resourceType: z().nullable(),
	resourceId: z().nullable(),
	request: q(z(), U()),
	result: q(z(), U()),
	latencyMs: V().nullable(),
	modelCalls: G(K({
		purpose: z(),
		provider: z(),
		model: z(),
		inputTokens: V().nullable(),
		outputTokens: V().nullable(),
		latencyMs: V().nullable(),
		status: z()
	})),
	createdAt: z()
}), Ks = K({
	byModel: G(K({
		purpose: z(),
		provider: z(),
		model: z(),
		calls: V(),
		failed: V(),
		inputTokens: V(),
		outputTokens: V(),
		avgLatencyMs: V().nullable()
	})),
	recent: G(K({
		id: z(),
		purpose: z(),
		provider: z(),
		model: z(),
		inputTokens: V().nullable(),
		outputTokens: V().nullable(),
		latencyMs: V().nullable(),
		retentionPolicy: z(),
		status: z(),
		error: z().nullable(),
		createdAt: z()
	}))
}), qs = K({
	allowedProviders: G(z().max(64)).max(20),
	egressMode: J(ss),
	requireZeroRetention: H(),
	promptLogging: J(cs),
	dailyTokenBudget: V().int().positive().nullable()
}), Js = qs.extend({
	customised: H(),
	runtime: K({
		llmProvider: z(),
		models: q(z(), z()),
		embeddingSpace: z(),
		parser: z()
	})
}), Ys = [
	Q.CLASSIFY,
	Q.EXTRACT,
	Q.SYNTHESIZE,
	Q.ANSWER,
	Q.VISION_PARSE
], Xs = K({
	name: z().trim().min(1).max(128),
	provider: J(is),
	baseUrl: z().trim().url().max(2e3).optional(),
	apiKey: z().min(1).max(4e3).optional()
}), Zs = K({
	name: z().trim().min(1).max(128).optional(),
	baseUrl: z().trim().url().max(2e3).nullable().optional(),
	apiKey: z().min(1).max(4e3).nullable().optional()
}), Qs = K({
	id: z(),
	name: z(),
	provider: J(is),
	baseUrl: z().nullable(),
	hasKey: H(),
	keyHint: z().nullable(),
	status: J(as),
	lastTestedAt: z().nullable(),
	lastError: z().nullable(),
	internal: H(),
	boundPurposes: G(z()),
	createdAt: z()
}), $s = K({ model: z().trim().min(1).max(128) }), ec = K({
	connectionId: z().uuid(),
	model: z().trim().min(1).max(128)
}), tc = K({
	purpose: z(),
	source: J([
		"connection",
		"environment",
		"none"
	]),
	connectionId: z().nullable(),
	connectionName: z().nullable(),
	provider: z().nullable(),
	model: z().nullable()
});
//#endregion
export { ns as ActorType, yo as AdminRole, as as AiConnectionStatus, is as AiProvider, rs as AuditAction, Ys as BINDABLE_MODEL_PURPOSES, Uo as BlockType, Wo as ChunkKind, ds as CitationKind, Z as DocType, zo as DocumentSource, Ro as DocumentStatus, ss as EgressMode, Qo as FeedbackScope, $o as FeedbackStatus, Xo as FeedbackTargetType, Zo as FeedbackVerdict, Yo as InstrumentRole, l as InvitationState, es as LessonStatus, c as MembershipStatus, Q as ModelPurpose, X as NotificationAudienceType, To as NotificationCampaignStatus, Eo as NotificationChannel, r as OrganizationRole, Ho as ParserProvider, t as PermissionAction, n as PermissionSubject, qo as PriceTargetAction, cs as PromptLogging, s as ROLE_PERMISSION_PRESETS, Go as Rating, Ko as RatingAction, os as RetentionPolicy, ls as RetrievalMode, us as RetrievalRoute, Jo as ReviewStatus, Bo as StepName, Vo as StepStatus, ts as Surface, wo as adminDashboardStatsSchema, xo as adminIdentitySchema, So as adminRecordSchema, bo as adminRoleSchema, Qs as aiConnectionSchema, Js as aiPolicyResponseSchema, qs as aiPolicySchema, e as appConfig, bs as askHistoryEntrySchema, vs as askHistoryQuerySchema, ys as askHistorySummarySchema, Gs as auditEventItemSchema, Ao as campaignRecipientSchema, No as campaignRecordSchema, Po as campaignStatsSchema, $ as citationSchema, xs as clearAskHistoryQuerySchema, Ps as confirmNoteResponseSchema, Ns as confirmNoteSchema, Xs as createAiConnectionSchema, Is as documentPageSummarySchema, Ss as documentSummarySchema, ho as domainMembershipSchema, po as domainOrganizationSchema, fo as domainUserSchema, Ws as exportAuditEventsQuerySchema, zs as feedbackItemSchema, Fs as feedbackResponseSchema, i as formatPermission, vo as invitationRecordSchema, ks as keyPointSchema, Bs as lessonItemSchema, Us as listAuditEventsQuerySchema, Fo as listCampaignsParamsSchema, ws as listDocumentsQuerySchema, js as listNotesQuerySchema, tc as modelBindingSchema, Ks as modelUsageSchema, Oo as notificationAudienceTypeSchema, ko as notificationCampaignStatusSchema, Do as notificationChannelSchema, Io as notificationSendPointSchema, Lo as notificationStatsSchema, Es as pageHighlightQuerySchema, Ds as pageRenderResponseSchema, a as parsePermission, fs as rectSchema, Ts as reprocessDocumentSchema, As as researchNoteSchema, Os as researchNoteSummarySchema, Ls as researchOverviewSchema, ps as retrievalFiltersSchema, ms as retrievalRequestSchema, _s as retrievalResponseSchema, hs as retrievedChunkSchema, Rs as reviewQueueItemSchema, mo as roleSummarySchema, jo as sendCampaignAudienceSchema, Mo as sendCampaignSchema, ec as setModelBindingSchema, Co as signupPointSchema, Cs as stepRunSummarySchema, Ms as submitFeedbackSchema, gs as tableHitSchema, $s as testAiConnectionSchema, Zs as updateAiConnectionSchema, Vs as updateLessonSchema, _o as userMeResponseSchema };
